export const RetriggerRasnEvent = (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    height="20" width="20"
  >
    <title>Retrigger RASN events</title>
    <path fill="#000000" d="M5.675 19.75C7.50833 21.25 9.61667 22 12 22c1.5833 0 3.075 -0.35 4.475 -1.05 1.4 -0.7 2.575 -1.6833 3.525 -2.95v2h2v-6h-6v2h2.9c-0.7 1.25 -1.6667 2.2292 -2.9 2.9375C14.7667 19.6458 13.4333 20 12 20c-0.232 0 -0.4608 -0.0089 -0.6864 -0.0268l4.9862 -9.7232h-3.5V4.03659c1.512 0.14065 2.8787 0.68679 4.1002 1.63841 1.4333 1.11667 2.3833 2.55833 2.85 4.325h2.05c-0.4833 -2.33333 -1.6417 -4.25 -3.475 -5.75C16.4917 2.75 14.3833 2 12 2c-1.5833 0 -3.075 0.35 -4.475 1.05C6.125 3.75 4.95 4.73333 4 6V4H2v6h6V8H5.1C5.8 6.75 6.76667 5.77083 8 5.0625 9.23333 4.35417 10.5667 4 12 4c0.2648 0 0.5254 0.01165 0.7819 0.03494L7.7998 13.75h3.5v6.2221c-1.55161 -0.1256 -2.95155 -0.6746 -4.1998 -1.6471C5.66667 17.2083 4.71667 15.7667 4.25 14H2.2c0.48333 2.3333 1.64167 4.25 3.475 5.75Z"></path>
  </svg>
)
